import React from 'react'
import PropTypes from 'prop-types'

import { Form } from '@domain-group/suit-theme'

const getErrorMessage = (time) => {
  if (!time) return ''

  if (!time.match(/^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/)) return 'Invalid format'

  return ''
}

const ServiceItem = (props) => {
  const {
    callbacks: { updateDeadlinesParam },
    deadlines,
    service,
  } = props

  const payload = deadlines[`service_${service.id}`] || {}

  return (
    <Form.Field errorMessage={getErrorMessage(payload.time)} marginTop="large" label={service.title}>
      <input
        type="text"
        value={payload.time || ''}
        onChange={e => updateDeadlinesParam(e.target.value, `service_${service.id}`)}
        name={`service_${service.id}`}
      />
    </Form.Field>
  )
}

ServiceItem.propTypes = {
  callbacks: PropTypes.object.isRequired,
  deadlines: PropTypes.object.isRequired,
  service: PropTypes.object.isRequired,
}

export default ServiceItem
